var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-eye-on';
                    var viewUrl = 'sprite.svg#view-icon-eye-on';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };